import {
  downloadFailedRegistration,
  failedMerchantRegistrationDetail,
  failedmerchantRegistrations,
  merchantRegistrationDetail,
  merchantRegistrations,
  registrationMerchantCSVBulk
} from '../../utils/api';
import { FAILED, LOADING, SET_DATA, SUCCESS } from './constants';

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

export function setData(data, key) {
  return { type: SET_DATA, data, key };
}

export function fetchMerchantRegistrations(params = {}) {
  return async (dispatch, getState) => {
    const { totalPage } = getState().merchantRegistrations.dataMerchantRegistrations.meta;

    let dataList  = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }else{
      const key = 'MerchantRegistrations';
      try {
        if (params?.page !== 1 && params?.page !== '1') {
          // dispatch(successAction({ data : [] }, key));
          dataList = getState().merchantRegistrations.dataMerchantRegistrations.data;
        }
        dispatch(loadingAction(true, key));
        const requestParams = {
          ...params,
          size: 100,
        };
        let { data, meta } = await merchantRegistrations(requestParams);

        dispatch(setData({ data: [ ...dataList, ...data] , meta }, key));
      } catch (error) {
        dispatch(failedAction(error.message, key));
      }
    }
  };
}

export function fetchFailedMerchantRegistrations(params = {}) {
  return async (dispatch, getState) => {

    const { totalPage } = getState().merchantRegistrations.dataFailedMerchantRegistrations.meta;
    let dataList  = [];
    if (params.page > 1 && params.page > totalPage) {
      return;
    }else{

      const key = 'FailedMerchantRegistrations';
      try {
        if (params?.page !== 1 && params?.page !== '1') {
          // dispatch(successAction({ data : [] }, key));
          dataList = getState().merchantRegistrations.dataFailedMerchantRegistrations.data;
        }

        dispatch(loadingAction(true, key));
        const requestParams = {
          ...params,
          size: 100,
        };
        let { data, meta } = await failedmerchantRegistrations(requestParams);

        dispatch(setData({ data: [ ...dataList, ...data] , meta }, key));
      } catch (error) {
        dispatch(failedAction(error.message, key));
      }
    }
  };
}

export function fetchMerchantRegistrationDetail(id = '', type) {
  return async (dispatch) => {
    const key = 'MerchantRegistrationDetail';

    try {
      dispatch(loadingAction(true, key));
      const { data } = type === 'failed' ? await failedMerchantRegistrationDetail(id) : await merchantRegistrationDetail(id);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function fetchDownloadFailedRegistration(params) {
  return async (dispatch) => {
    const key = 'downloadFailedRegistration';

    try {
      dispatch(loadingAction(true, key));
      const { data } = await downloadFailedRegistration(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function clearError(){
  return async (dispatch) => {
    const key = 'ErrorUnduhLog';
    dispatch(failedAction(false,key));
  };
}

export function seterrorUnduh() {
  return async (dispatch) => {
    const key = 'ErrorUnduh';
    dispatch(loadingAction(true, key));
    setTimeout(() => {
      dispatch(failedAction(true, key));
      dispatch(loadingAction(false, key));
    });
  };
}

export function setRegistrationFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'Filter'));
  };
}

export function setRegistrationFailedFilter(filter) {
  return async (dispatch) => {
    dispatch(successAction(filter, 'FailedFilter'));
  };
}

export const submitRegistration = (file = {}, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitRegistration';
    dispatch(loadingAction(true, key));
    callback();
    try {
      const { data } = await registrationMerchantCSVBulk(file.file);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};
